import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import { PaginationQueryParams } from '@forwardflow/types'
import useSWR from 'swr'

export const useActiveCampaigns = (queryParams: PaginationQueryParams) => {
   const response = useSWR(
      [QUERY_KEYS.GET_ALL_ACTIVE_CAMPAIGNS, { ...queryParams }],
      () => CampaignService.getActiveCampaigns(queryParams)
   )
   return {
      ...response,
   }
}
